<template>
  <div class="personal-data-form-container">
    <div class="form-wrapper">
      <!-- Header Section -->
      <div class="header-section">
        <div class="header-content">
          <div class="main-content">
            <h1 class="form-title">Datos personales</h1>
            <p class="form-subtitle">
              Ingresa los datos para obtener tu cotización
            </p>
            
            <!-- Program Selection -->
            <div class="program-selection">
              <div class="program-badge">
                <span 
                  style="
                    font-family: 'Poppins', sans-serif;
                    font-weight: 400;
                    font-style: normal;
                    font-size: 14px;
                    line-height: 22px;
                    letter-spacing: 0px;
                    color: #4E4F55;
                  "
                >Programa:</span><br>
                <span class="program-text"> <img src="/images/iconos/done.svg" alt="puntos-up" class="puntos-mobile-up"> {{ selectedProgram }}</span>
              </div>
            </div>
          </div>

          <!-- Discount Banner -->
          <div class="discount-banner">
            <div class="discount-content">
              <div class="discount-badge">50%</div>
              <p class="discount-text">
                Sólo matriculando online<br>
                obtén hasta un <strong>50% de descuento</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Fields -->
      <form 
        id="personalDataForm"
        @submit.prevent="ifFormValid($event, handleSubmit)" 
        class="form-content"
      >
        <!-- Row 1: Nombre and Primer apellido -->
        <div class="form-row">
          <div class="form-group form-field">
            <label class="field-label" for="firstName">Nombre del estudiante <span class="required-asterisk">*</span></label>
            <input
              v-model="formData.firstName"
              type="text"
              id="firstName"
              name="firstName"
              class="form-input"
              placeholder="Ingresa tu nombre"
              onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
              maxlength="30"
              @input="validateField('firstName')"
              @blur="validateField('firstName')"
            />
          </div>
          <div class="form-group form-field">
            <label class="field-label" for="firstLastName">Primer apellido <span class="required-asterisk">*</span></label>
            <input
              v-model="formData.firstLastName"
              type="text"
              id="firstLastName"
              name="firstLastName"
              class="form-input"
              placeholder="Ingresa tu primer apellido"
              onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
              maxlength="12"
              @input="validateField('firstLastName')"
              @blur="validateField('firstLastName')"
            />
          </div>
        </div>

        <!-- Row 2: Segundo apellido and Fecha de nacimiento -->
        <div class="form-row">
          <div class="form-group form-field">
            <label class="field-label" for="secondLastName">Segundo apellido <span class="required-asterisk">*</span></label>
            <input
              v-model="formData.secondLastName"
              type="text"
              id="secondLastName"
              name="secondLastName"
              class="form-input"
              placeholder="Ingresa tu segundo apellido"
              onkeypress="return /[a-zA-ZáéíóúÁÉÍÓÚñÑ ]/.test(event.key)"
              maxlength="12"
              @input="validateField('secondLastName')"
              @blur="validateField('secondLastName')"
            />
          </div>
          
          <div class="form-group form-field">
            <label class="field-label" for="birthDate">Fecha de nacimiento <span class="required-asterisk">*</span></label>
            <vue-mask
              placeholder="dd/mm/aaaa"
              mask="DA/MO/YEXR"
              :raw="false"
              v-model="formData.birthDate"
              :options="dateMaskOptions"
              id="birthDate"
              name="birthDate"
              class="form-input"
              @input="validateField('birthDate')"
              @blur="validateField('birthDate')"
            />
          </div>
        </div>

        <!-- Row 3: Email and RUT -->
        <div class="form-row">
          <div class="form-group form-field">
            <label class="field-label" for="email">Mail <span class="required-asterisk">*</span></label>
            <input
              v-model="formData.email"
              type="email"
              id="email"
              name="email"
              class="form-input"
              placeholder="ejemplo@correo.com"
              maxlength="50"
              @input="validateField('email')"
              @blur="validateField('email')"
            />
          </div>
          
          <div class="form-group form-field">
            <label class="field-label" for="rut">RUT <span class="required-asterisk">*</span></label>
            <input
              v-model="formData.rut"
              type="text"
              id="rut"
              name="rut"
              class="form-input"
              placeholder="00.000.000-K"
              maxlength="12"
              @input="handleRutInput($event, 'rut')"
              @blur="handleRutBlur($event, 'rut')"
              @keypress="handleRutKeypress($event)"
            />
          </div>
        </div>

        <!-- Row 4: Celular y Sede de preferencia -->
        <div class="form-row">
          <div class="form-group form-field">
            <label class="field-label" for="phoneNumber">Celular <span class="required-asterisk">*</span></label>
            <div class="phone-input-container">
              <select class="country-code-select">
                <option value="+56">+56</option>
              </select>
              <input
                v-model="formData.phoneNumber"
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                class="form-input phone-number-input"
                placeholder="900000000"
                maxlength="9"
                @input="onPhoneInput"
                @blur="onPhoneBlur"
                @keyup="onPhoneKeyup"
                @change="onPhoneChange"
              />
            </div>
            <div class="errorContainer"></div>
            <div v-if="phoneError" class="validation-message phone-error">
              {{ !formData.phoneNumber || formData.phoneNumber.trim() === '' 
                 ? VALIDATION_MESSAGES.required.phoneNumber 
                 : VALIDATION_MESSAGES.format.phoneNumber }}
            </div>
            <!-- Campo hidden para el mixin de validación -->
            <input
              type="hidden"
              name="phoneNumber"
              :value="formData.phoneNumber"
              data-rule-required="true"
              data-msg-required="Debes ingresar un número de celular"
            />
            
            <!-- Texto de contacto -->
            <div class="contact-text">
              Al continuar acepto que Preuniversitario Pedro de Valdivia me contacte por teléfono y otros canales
            </div>
          </div>
          
          <div class="form-group form-field" v-if="showPreferredVenue">
            <label class="field-label" for="sede">Sede de preferencia <span class="required-asterisk">*</span></label>
            <multiselect
              v-model="formData.preferredLocation"
              :options="filteredVenueOptions"
              id="sede"
              name="sede"
              placeholder="Seleccionar sede de preferencia"
              track-by="id"
              :custom-label="formatLocationLabel"
              :showLabels="false"
              class="multiselect-custom"
              @input="validateField('sede')"
              @blur="validateField('sede')"
            />

            <input
              type="hidden"
              name="sede"
              :value="preferredVenue ? formData.preferredLocation.name : ''"
            />
            <input
              type="hidden"
              name="sede"
              :value="preferredVenue ? preferredVenue.name : ''"
              data-rule-required="true"
              data-msg-required="Debes seleccionar una sede"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import formValidation from "@/mixins/formValidation";
import rutValidation from "@/mixins/rutValidation";
import vueMask from "vue-jquery-mask";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { VALIDATION_MESSAGES, VALIDATION_REGEX } from "@/constants/validationMessages";
import ignoredVenues from "@/constants/ignoredVenues.json";
import { cleanLocationDisplayName, getLocationDisplayName } from "@/utils/locationName";

export default {
  name: 'PersonalDataForm',
  components: {
    vueMask,
    Multiselect,
  },
  mixins: [formValidation, rutValidation],
  props: {
    stepperData: {
      type: Object,
      default: () => ({})
    },
    step1Data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      VALIDATION_MESSAGES,
      VALIDATION_REGEX,
      selectedProgram: this.getProgramNameFromStep1(),
      selectedProgramId: this.getProgramIdFromStep1(),
      syncingFromStepper: false,
      phoneError: false,
      phoneFieldTouched: false,
      formData: {
        firstName: '',
        firstLastName: '',
        secondLastName: '',
        rut: '',
        email: '',
        phoneNumber: '',
        birthDate: '',
        preferredLocation: null,
        authorizationPublicitary: true
      },
      venueOptions: [],
      dateMaskOptions: {
        translation: {
          D: { pattern: /[0-3]/ },
          A: { pattern: /[0-9]/ },
          M: { pattern: /[0-1]/ },
          O: { pattern: /[0-9]/ },
          Y: { pattern: /[1-2]/ },
          E: { pattern: /[0-9]/ },
          X: { pattern: /[0-9]/ },
          R: { pattern: /[0-9]/ }
        }
      }
    }
  },
  computed: {
    isFormValid() {
      // Validar RUT usando el nuevo mixin
      const rutValidation = this.validateRutChile(this.formData.rut);
      
      // Verificar que no hay mensajes de error visibles
      const hasVisibleErrors = document.querySelectorAll('#personalDataForm .form-group.error').length > 0;
      
      // Validar formato de email
      const emailValid = this.formData.email && this.formData.email.trim() && this.VALIDATION_REGEX.email.test(this.formData.email);
      
      // Validar formato de teléfono
      const phoneValid = this.formData.phoneNumber && this.formData.phoneNumber.trim() && this.VALIDATION_REGEX.phone.test(this.formData.phoneNumber);
      
      const baseValidation = this.formData.firstName && 
                           this.formData.firstLastName && 
                           this.formData.rut && 
                           rutValidation.isValid &&
                           emailValid &&
                           phoneValid &&
                           this.formData.birthDate &&
                           this.formData.birthDate.length >= 10 &&
                           !hasVisibleErrors;
      
      // Solo validar preferredLocation si se muestra el campo (no es PDVx)
      if (this.showPreferredVenue) {
        const isValid = baseValidation && this.formData.preferredLocation;
        return isValid;
      }

      return baseValidation;
    },
    preferredVenue() {
      return this.formData.preferredLocation;
    },
    filteredVenueOptions() {
      // Filtrar "Alameda" de las opciones
      return this.venueOptions.filter(venue => {
        const venueName = getLocationDisplayName(venue);
        return !venueName.toLowerCase().includes('alameda');
      });
    },
    showPreferredVenue() {
      // Obtener el nombre del programa del Step1
      let programName = '';
      
      if (this.step1Data && this.step1Data.program) {
        if (this.step1Data.program.name) {
          programName = this.step1Data.program.name;
        } else if (typeof this.step1Data.program === 'string') {
          programName = this.step1Data.program;
        }
      }
      
      // Si no hay programa del Step1, usar el selectedProgram
      if (!programName && this.selectedProgram) {
        programName = this.selectedProgram;
      }
      
      // Si hay un nombre de programa, verificar si es PDVx
      if (programName) {
        const lowerProgramName = programName.trim().toLowerCase();
        // Ocultar para programas PDVx
        if (lowerProgramName.includes("pdvx")) {
          return false;
        }
      }
      
      // Por defecto, mostrar el campo
      return true;
    },
    isPdvXProgram() {
      // Obtener el nombre del programa del Step1
      let programName = '';
      
      if (this.step1Data && this.step1Data.program) {
        if (this.step1Data.program.name) {
          programName = this.step1Data.program.name;
        } else if (typeof this.step1Data.program === 'string') {
          programName = this.step1Data.program;
        }
      }
      
      // Si no hay programa del Step1, usar el selectedProgram
      if (!programName && this.selectedProgram) {
        programName = this.selectedProgram;
      }
      
      // Verificar si es PDVx
      if (programName) {
        const lowerProgramName = programName.trim().toLowerCase();
        return lowerProgramName.includes("pdvx") || lowerProgramName.includes("pdv online");
      }
      
      return false;
    },
    // Computed para obtener el nombre del programa del Step1
    programNameFromStep1() {
      return this.getProgramNameFromStep1();
    }
  },
  watch: {
    preferredVenue() {
      this.$nextTick(() => {
        const hiddenInput = document.getElementsByName("sede")[0];
        if (hiddenInput) {
          hiddenInput.dispatchEvent(new Event("change"));
        }
      });
    },
    // Sincronizar con datos del stepper cuando cambien
    'stepperData.step2': {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.syncWithStepperData(newData);
        }
      },
      immediate: true,
      deep: true
    },
    
    // Watcher para stepperData completo
    stepperData: {
      handler(newData) {
        if (newData && newData.step2 && Object.keys(newData.step2).length > 0) {
          this.syncWithStepperData(newData.step2);
        }
      },
      immediate: true,
      deep: true
    },
    // Sincronizar con datos del Step1 cuando cambien
    step1Data: {
      handler(newData) {
        if (newData && newData.program) {
          this.selectedProgram = this.getProgramNameFromStep1();
          this.selectedProgramId = this.getProgramIdFromStep1();
          
          // Si es un programa PDVx, establecer la sede virtual como preferredLocation
          if (this.isPdvXProgram) {
            this.setPdvXVirtualLocation();
          }
        }
      },
      immediate: true,
      deep: true
    },
    
    // Watcher para isFormValid
    isFormValid: {
      handler() {
      },
      immediate: true
    },
    
    // Watcher para el campo de celular
    'formData.phoneNumber': {
      handler(newVal) {
        // Solo validar si el campo ha sido tocado o si hay un valor
        if (this.phoneFieldTouched || (newVal && newVal.trim() !== '')) {
          this.validatePhone();
        }
      },
      immediate: false
    },
    
    // Watcher para preferredLocation
    'formData.preferredLocation': {
      handler() {
        // Validar el campo sede cuando cambie la selección
        this.$nextTick(() => {
          this.validateHeadquartersField();
        });
      },
      immediate: true
    },
    
    // Watcher para venueOptions
    venueOptions: {
      handler(newOptions) {
        if (newOptions.length > 0 && !this.formData.preferredLocation) {
          this.tryToSetPreferredLocation();
        }
      },
      immediate: true
    },
    // Emitir cambios cuando el formulario cambie (solo si no está en modo de sincronización)
    formData: {
      handler() {
        // Solo emitir si no estamos sincronizando datos del stepper
        if (!this.syncingFromStepper) {
          this.emitStepperUpdate();
        }
      },
      deep: true
    },
    // Observar cambios en selectedProgram
    selectedProgram: {
      handler() {
        
        // Si es un programa PDVx, establecer la sede virtual como preferredLocation
        if (this.isPdvXProgram) {
          this.setPdvXVirtualLocation();
        }
      },
      immediate: true
    },
    // Observar cambios en isPdvXProgram
    isPdvXProgram: {
      handler(isPdvX) {
        
        if (isPdvX) {
          // Establecer la sede virtual como preferredLocation para PDVx
          this.setPdvXVirtualLocation();
        }
      },
      immediate: true
    },
    // Actualizar validaciones cuando cambie la visibilidad del campo sede
    showPreferredVenue: {
      handler() {
        this.$nextTick(() => {
          // Validar el campo sede cuando cambie la visibilidad
          this.validateHeadquartersField();
          
          // Actualizar validaciones del formulario
          const form = window.$("#personalDataForm");
          if (form.length) {
            form.validator('update');
          }
        });
      }
    }
  },
  methods: {
    formatLocationLabel(location) {
      return cleanLocationDisplayName(location);
    },

    getProgramNameFromStep1() {
      let programName = '';
      
      if (this.step1Data && this.step1Data.program) {
        // Si tenemos el programa completo del Step1, usar su nombre completo
        if (this.step1Data.program.name) {
          programName = this.step1Data.program.name;
        }
        // Si solo tenemos el nombre como string
        else if (typeof this.step1Data.program === 'string') {
          programName = this.step1Data.program;
        }
      }
      // Fallback al valor guardado en stepperData o valor por defecto
      else if (this.stepperData && this.stepperData.selectedProgram) {
        programName = this.stepperData.selectedProgram;
      }
      else {
        programName = 'Tradicional 4° Medio'; // Valor por defecto
      }
      
      // Limpiar el nombre del programa removiendo información del año
      return this.cleanProgramName(programName);
    },
    
    getProgramIdFromStep1() {
      let programId = null;
      
      if (this.step1Data && this.step1Data.program) {
        // Si tenemos el programa completo del Step1, usar su ID
        if (this.step1Data.program.id) {
          programId = this.step1Data.program.id;
        }
      }
      // Fallback al valor guardado en stepperData
      else if (this.stepperData && this.stepperData.selectedProgramId) {
        programId = this.stepperData.selectedProgramId;
      }
      
      return programId;
    },
    
    cleanProgramName(programName) {
      if (!programName) return '';
      
      // Construir el formato completo del programa
      return this.buildFullProgramName(programName);
    },
    
    buildFullProgramName(programName) {
      if (!programName) return '';
      
      // Extraer componentes del nombre del programa
      let baseName = '';
      let year = '';
      let modality = '';
      
      // Detectar el nombre base (antes de cualquier año o modalidad)
      if (programName.toLowerCase().includes('sube nota')) {
        baseName = 'Sube Nota';
        
        // Extraer año
        const yearMatch = programName.match(/(\d+°\s*medio)/i);
        if (yearMatch) {
          year = yearMatch[1];
        }
        
        // Detectar modalidad
        if (programName.toLowerCase().includes('presencial')) {
          modality = 'Presencial';
        } else if (programName.toLowerCase().includes('online')) {
          modality = 'Online';
        } else {
          modality = 'Presencial'; // Por defecto
        }
        
        // Construir el formato completo
        const fullName = `${baseName} / ${year} / ${modality} (${baseName} ${year})`;
        return fullName;
      }
      
      // Para otros programas, mantener el nombre original
      return programName;
    },
    syncWithStepperData(stepperData) {
      // Marcar que estamos sincronizando desde el stepper para evitar bucles
      this.syncingFromStepper = true;
      
      // Sincronizar datos del stepper con el formulario local
      if (stepperData.firstName) {
        this.formData.firstName = stepperData.firstName;
      }
      if (stepperData.firstLastName) {
        this.formData.firstLastName = stepperData.firstLastName;
      }
      if (stepperData.secondLastName) {
        this.formData.secondLastName = stepperData.secondLastName;
      }
      if (stepperData.rut) {
        this.formData.rut = stepperData.rut;
      }
      if (stepperData.email) {
        this.formData.email = stepperData.email;
      }
      if (stepperData.phoneNumber) {
        this.formData.phoneNumber = stepperData.phoneNumber;
      }
      if (stepperData.birthDate) {
        this.formData.birthDate = stepperData.birthDate;
      }
      
      // Lógica mejorada para preferredLocation
      if (this.isPdvXProgram) {
        // Si es PDVx, siempre establecer la sede virtual si no existe
        if (!this.formData.preferredLocation) {
          this.setPdvXVirtualLocation();
        }
      } else {
        // Si NO es PDVx, sincronizar preferredLocation del stepper
        if (stepperData.preferredLocation) {
          this.formData.preferredLocation = stepperData.preferredLocation;
        } else {
          
          // Intentar encontrar la sede en las opciones disponibles si hay un nombre
          if (stepperData.preferredLocationName && this.venueOptions.length > 0) {
            const foundLocation = this.venueOptions.find(venue => 
              venue.name === stepperData.preferredLocationName
            );
            if (foundLocation) {
              this.formData.preferredLocation = foundLocation;
            }
          }
        }
      }
      
      if (stepperData.selectedProgram) {
        this.selectedProgram = stepperData.selectedProgram;
      }
      if (stepperData.selectedProgramId) {
        this.selectedProgramId = stepperData.selectedProgramId;
      }
      
      // Resetear la bandera después de sincronizar
      this.$nextTick(() => {
        this.syncingFromStepper = false;
        
        // Validar el campo de celular después de sincronizar solo si ya fue tocado
        if (this.formData.phoneNumber && this.phoneFieldTouched) {
          this.validatePhone();
        }
      });
    },
    emitStepperUpdate() {
      // Construir preferredLocation con estructura completa
      let preferredLocation = this.formData.preferredLocation;
      
      // Si hay una sede seleccionada, asegurar que tenga la estructura completa
      if (preferredLocation) {
        preferredLocation = {
          id: preferredLocation.id,
          communeId: preferredLocation.communeId,
          name: preferredLocation.name,
          displayName: getLocationDisplayName(preferredLocation),
          address: preferredLocation.address || '',
          City: preferredLocation.City || { name: '' }
        };
      }
      // Emitir datos actualizados al stepper
      this.$emit('update-stepper', {
        firstName: this.formData.firstName,
        firstLastName: this.formData.firstLastName,
        secondLastName: this.formData.secondLastName,
        rut: this.formData.rut,
        email: this.formData.email,
        phoneNumber: this.formData.phoneNumber,
        birthDate: this.formData.birthDate,
        preferredLocation: preferredLocation,
        authorizationPublicitary: true,
        selectedProgram: this.selectedProgram,
        selectedProgramId: this.selectedProgramId,
        isFormValid: this.isFormValid
      });
    },
    getAllLocations() {
      this.Axios.get("/locations").then(
        (response) => {
          // Mapear los datos para incluir toda la información necesaria
          const excludedNames = new Set(ignoredVenues);
          this.venueOptions = response.data
            .map(location => {
            return {
              id: location.id,
              name: location.name,
              displayName: cleanLocationDisplayName(location),
              communeId: location.Commune?.id || location.communeId,
              address: location.address || '',
              City: location.City || null,
              Commune: location.Commune || null
            };
            })
            .filter(loc => !excludedNames.has(loc.displayName))
            .sort((a, b) => a.displayName.localeCompare(b.displayName, 'es', { sensitivity: 'base' }));
          
          // Después de cargar las sedes, intentar establecer la sede correcta
          this.$nextTick(() => {
            this.tryToSetPreferredLocation();
          });
        }
      );
    },
    formatRut() {
      // Este método ya no se necesita porque vue-mask se encarga del formato
    },
    handleSubmit() {
      // Este método será llamado solo si la validación es exitosa
      this.emitStepperUpdate();
      this.$emit('form-submitted', this.formData);
    },
    
    validateField(fieldName) {
      // Validar campo específico en tiempo real
      const form = window.$("#personalDataForm");
      if (form.length) {
        const field = form.find(`[name="${fieldName}"]`);
        if (field.length) {
          // Validación especial para sede
          if (fieldName === 'sede') {
            this.validateHeadquartersField();
            return;
          }
          
          // Trigger validation for specific field
          field.valid();
          
          // Validación específica para celular
          if (fieldName === 'phoneNumber') {
            this.validatePhone();
          }
          
          // Validación específica para RUT - MANEJADA POR EL MIXIN
          // No agregar validación manual aquí para evitar duplicación de mensajes
          
          // Actualizar estado visual del campo
          this.$nextTick(() => {
            const formGroup = field.closest('.form-group');
            if (field.valid()) {
              formGroup.removeClass('error').addClass('success');
            } else {
              formGroup.removeClass('success').addClass('error');
            }
          });
        }
      }
    },

    validateHeadquartersField() {
      // Validación personalizada para el campo sede usando DOM nativo
      this.$nextTick(() => {
        const sedeField = document.querySelector('#personalDataForm [name="sede"]');
        if (sedeField) {
          const formGroup = sedeField.closest('.form-group');
          
          // Solo validar si el campo está visible
          if (this.showPreferredVenue) {
            if (!this.formData.preferredLocation) {
              formGroup.classList.remove('success');
              formGroup.classList.add('error');
              
              // Mostrar mensaje de error usando DOM nativo
              let errorMsg = formGroup.querySelector('.validation-message');
              if (!errorMsg) {
                errorMsg = document.createElement('div');
                errorMsg.className = 'validation-message';
                errorMsg.textContent = 'Debes seleccionar una sede';
                formGroup.appendChild(errorMsg);
              }
            } else {
              formGroup.classList.remove('error');
              formGroup.classList.add('success');
              
              // Remover mensaje de error
              const existingErrorMsg = formGroup.querySelector('.validation-message');
              if (existingErrorMsg) {
                existingErrorMsg.remove();
              }
            }
          } else {
            // Si no se muestra el campo, remover errores
            formGroup.classList.remove('error', 'success');
            const existingErrorMsg = formGroup.querySelector('.validation-message');
            if (existingErrorMsg) {
              existingErrorMsg.remove();
            }
          }
        }
        
        this.emitStepperUpdate();
      });
    },
    
    validatePhone() {
      
      // Solo validar si el usuario ha interactuado con el campo
      if (!this.phoneFieldTouched) {
        return;
      }
      
      // Limpiar el error anterior
      this.phoneError = false;
      
      if (!this.formData.phoneNumber || this.formData.phoneNumber.trim() === '') {
        // Campo vacío
        this.phoneError = true;
      } else {
        // Validar que solo contenga números y tenga exactamente 9 dígitos
        const isValid = VALIDATION_REGEX.phone.test(this.formData.phoneNumber);
        this.phoneError = !isValid;
      }
      
      // Forzar actualización de la vista
      this.$forceUpdate();
    },
    
    // Métodos para manejar eventos del campo de celular
    onPhoneInput() {
      this.phoneFieldTouched = true;
      this.validatePhone();
    },
    
    onPhoneBlur() {
      this.phoneFieldTouched = true;
      this.validatePhone();
    },
    
    onPhoneKeyup() {
      this.phoneFieldTouched = true;
      this.validatePhone();
    },
    
    onPhoneChange() {
      this.phoneFieldTouched = true;
      this.validatePhone();
    },
    
    // Validar formato de fecha personalizado
    validateDateFormat(dateString) {
      if (!dateString || dateString.length < 10) return false;
      
      const datePattern = /^(\d{2})\/(\d{2})\/(\d{4})$/;
      if (!datePattern.test(dateString)) return false;
      
      const parts = dateString.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      
      // Validar rangos básicos
      if (day < 1 || day > 31) return false;
      if (month < 1 || month > 12) return false;
      
      // Verificar que no sea en el futuro
      const currentDate = new Date();
      const inputDate = new Date(year, month - 1, day);
      if (inputDate > currentDate) return false;
      
      // Verificar que no sea muy antigua (antes de 1900)
      if (year < 1900) return false;
      
      // Verificar que la persona tenga al menos 10 años
      const minYear = currentDate.getFullYear() - 10;
      if (year > minYear) return false;
      
      // Validar meses con 30 días
      const months30 = [4, 6, 9, 11];
      if (months30.indexOf(month) !== -1 && day > 30) return false;
      
      // Validar febrero
      if (month === 2) {
        const isLeap = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        if (isLeap && day > 29) return false;
        if (!isLeap && day > 28) return false;
      }
      
      return true;
    },
    
    // Establecer la sede virtual como preferredLocation para programas PDVx
    setPdvXVirtualLocation() {
      
      // Crear el objeto de sede virtual basado en los datos del JSON proporcionado
      const virtualSede = {
        id: 42,
        communeId: 320,
        name: "Sede Virtual",
        address: "Avda. Apoquindo 5142, Las Condes, Chile",
        City: {
          name: "Las Condes"
        }
      };
      
      // Establecer la sede virtual como preferredLocation
      this.formData.preferredLocation = virtualSede;
      
      // Emitir el cambio inmediatamente
      this.$nextTick(() => {
        this.emitStepperUpdate();
      });
    },
    
    // Intentar establecer la sede preferida basándose en los datos disponibles
    tryToSetPreferredLocation() {
      
      // Si ya hay una sede establecida, no hacer nada
      if (this.formData.preferredLocation) {
        return;
      }
      
      // Si es PDVx, establecer sede virtual
      if (this.isPdvXProgram) {
        this.setPdvXVirtualLocation();
        return;
      }
      
      // Si no es PDVx, intentar encontrar la sede en el stepper o por nombre
      if (this.stepperData && this.stepperData.preferredLocation) {
        this.formData.preferredLocation = this.stepperData.preferredLocation;
        return;
      }
      
      // Si hay un nombre de sede en el stepper, buscarlo en las opciones
      if (this.stepperData && this.stepperData.preferredLocationName && this.venueOptions.length > 0) {
        const foundLocation = this.venueOptions.find(venue => 
          venue.name === this.stepperData.preferredLocationName
        );
        if (foundLocation) {
          this.formData.preferredLocation = foundLocation;
          return;
        }
      }
      
      // Si hay un selectedProgram, intentar encontrar una sede por defecto
      if (this.selectedProgram && this.venueOptions.length > 0) {
        // Buscar una sede que contenga "Plaza Egaña" o similar
        const defaultLocation = this.venueOptions.find(venue => 
          venue.name.toLowerCase().includes('plaza egaña')
        );
        if (defaultLocation) {
          this.formData.preferredLocation = defaultLocation;
          return;
        }
      }
    }
  },
  created() {
    this.getAllLocations();
    
    // Sincronizar con datos del stepper al crear el componente
    if (this.stepperData && Object.keys(this.stepperData).length > 0) {
      this.syncWithStepperData(this.stepperData);
    }
    
    // Sincronizar con datos del Step1 al crear el componente
    if (this.step1Data && this.step1Data.program) {
      this.selectedProgram = this.getProgramNameFromStep1();
      this.selectedProgramId = this.getProgramIdFromStep1();
    }
    
    // Verificación adicional para PDVx
    this.$nextTick(() => {
      if (this.isPdvXProgram && !this.formData.preferredLocation) {
        this.setPdvXVirtualLocation();
      }
      
      // Forzar emisión de datos después de un breve delay para asegurar sincronización
      setTimeout(() => {
        this.emitStepperUpdate();
      }, 500);
    });
  },
  mounted() {
    
    // Verificación adicional para preferredLocation
    this.$nextTick(() => {
      // Si no es PDVx y no hay preferredLocation, intentar sincronizar desde stepper
      if (!this.isPdvXProgram && !this.formData.preferredLocation && this.stepperData && this.stepperData.preferredLocation) {
        this.formData.preferredLocation = this.stepperData.preferredLocation;
      }
      
      // Forzar emisión de datos después de un delay para asegurar que todo esté sincronizado
      setTimeout(() => {
        this.emitStepperUpdate();
      }, 1000);
      
      // Validar el campo de celular si ya tiene un valor y fue tocado
      if (this.formData.phoneNumber && this.phoneFieldTouched) {
        this.validatePhone();
      }
    });
    
    // Configurar validaciones usando el mixin
    this.validateForm(
      window.$("#personalDataForm"),
      {
        firstName: {
          required: true,
          validName: true,
          maxlength: 30
        },
        firstLastName: {
          required: true,
          validName: true,
          maxlength: 12
        },
        secondLastName: {
          required: true,
          validName: true,
          maxlength: 12
        },
        rut: {
          required: true,
          rut: true,
          rutNoDuplicado: true,
          minlength: 10
        },
        email: {
          required: true,
          customEmail: true,
          minlength: 5,
          maxlength: 50
        },
        birthDate: {
          required: true,
          minlength: 10,
          maxlength: 10,
          dateFormat: true
        },
        phoneNumber: {
          required: true,
          minlength: 9,
          maxlength: 9
        },
        sede: {
          required: true,
        },
      },
      {
        firstName: {
          required: "Ingresa tu nombre",
          validName: "El nombre debe tener al menos 2 caracteres y solo letras",
          maxlength: "El nombre no puede exceder 30 caracteres"
        },
        firstLastName: {
          required: "Debes ingresar tu primer apellido",
          validName: "El primer apellido debe tener al menos 2 caracteres y solo letras",
          maxlength: "El primer apellido no puede exceder 12 caracteres"
        },
        secondLastName: {
          required: "Debes ingresar tu segundo apellido",
          validName: "El segundo apellido debe tener al menos 2 caracteres y solo letras",
          maxlength: "El segundo apellido no puede exceder 12 caracteres"
        },
        rut: {
          required: "Debes ingresar el RUT",
          rut: "El RUT ingresado no es válido",
          rutNoDuplicado: "Este RUT ya está registrado en el formulario",
          minlength: "El RUT debe tener el formato correcto (00.000.000-K)"
        },
        email: {
          required: "Debes ingresar un correo",
          email: "Debes ingresar un correo válido",
          minlength: "El correo debe tener al menos 5 caracteres",
          maxlength: "El correo no puede exceder 50 caracteres"
        },
        birthDate: {
          required: "Debes ingresar tu fecha de nacimiento",
          minlength: "Debes ingresar una fecha válida",
          maxlength: "La fecha debe tener el formato dd/mm/aaaa",
          dateFormat: "La fecha debe tener el formato dd/mm/aaaa"
        },
        phoneNumber: {
          required: "Debes ingresar un número de celular",
          minlength: "El número debe tener 9 dígitos",
          maxlength: "El número debe tener 9 dígitos"
        },
        sede: {
          required: "Debes seleccionar una sede",
        },
      },
      {
        ignore: "",
      }
    );
  },
}
</script>

<style scoped lang="scss">
/* Estilos de inputs y selects manejados por _inputs-shared.scss */
@import '@/assets/scss/_form-validation.scss';
@import '@/assets/scss/_inputs-shared.scss';
@import '@/assets/scss/_rut-validation.scss';

/* Estilos de multiselect manejados por _inputs-shared.scss */

/* Container */
.personal-data-form-container {
  max-width: 936px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Form Wrapper */
.form-wrapper {
  background-color: white;
  border-radius: 12px;
 
  margin-bottom: 2rem;
}

/* Header Section */
.header-section {
  margin-bottom: 2rem;
}

.header-content {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.main-content {
  flex: 1;
  max-width: 50%;
}

.form-title {
  font-family: "Poppins-Medium";
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 0.5rem 0;
  line-height: 1.2;
}

.form-subtitle {
  font-family: "Poppins-Medium";
  font-weight: 100;
  font-style: normal;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0px;
  color: #4E4F55;
  margin: 0 0 2rem 0;
  line-height: 1.5;
}

/* Program Selection */
.program-selection {
  margin-bottom: 0;
}

.program-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
  margin-bottom: 0.5rem;
}

.program-badge {
  display: inline-block;
  background: linear-gradient(245.07deg, #FFE25C 0%, #FFF2B7 100%);
  border-radius: 12px 12px 12px 12px;
  padding: 16px;
  min-height: 88px;
  width: 350px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.program-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
  color: #1a1a1a;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Discount Banner - Estilos base (desktop) */
.discount-banner {
  position: absolute;
  top: 50%;
  right: 90px;
  transform: translateY(-50%);
  z-index: 10;
}

.discount-content {
  width: 300px;
  height: 100px;
  background-color: white;
  border-radius: 12px;
  border: 2px solid #fbbf24;
  padding: 1rem 1.25rem;
  position: relative;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.discount-content::before {
  content: '';
  position: absolute;
  width: 200px;
  height: 89px;
  background-color: #FFEA8A;
  top: -42px;
  left: 199px;
  z-index: -1;
}

.discount-content::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 50px;
  background-color: #FFE25C;
  top: 60px;
  left: -20px;
  z-index: -1;
}

.discount-badge {
  position: absolute;
  top: -58px;
  right: -58px;
  background-color: #1a1a1a;
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  font-weight: 400;
  font-size: 1.5rem;
  font-family: "Poppins-Medium";
  letter-spacing: -0.02em;
  min-width: 88px;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.discount-text {
  color: #4a4a4a;
  font-weight: 400;
  margin: 4px;
  font-size: 0.9rem;
  line-height: 1.4;
  font-family: "Poppins-Medium";
}



/* Form Content */
.form-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

/* Form Row */
.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
}


/* Form Field */
.form-field {
  display: flex;
  flex-direction: column;
}

.field-label {
  font-family: "Poppins-Medium";
  font-size: 0.875rem;
  font-weight: 100;
  color: #374151;
  margin-bottom: 0.5rem;
}

.required-asterisk {
  color: #e53e3e;
  font-weight: 700;
}

/* Estilos de inputs y multiselect manejados por _inputs-shared.scss */

/* Animación de shake para errores */
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-5px); }
  75% { transform: translateX(5px); }
}

/* Information Box */
.info-box {
  background-color: #F0F7FF;
  border-left: 3px solid #3399FF;
  padding: 1rem;
  border-radius: 8px;
  margin: 1rem 0;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.info-text {
  font-size: 0.875rem;
  color: #1e40af;
  margin: 0;
  line-height: 1.5;
}

.phone-number-highlight {
  color: #1d4ed8;
  font-weight: 600;
}

/* Submit Button */
.submit-button {
  width: 100%;
  height: 48px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1rem;
}

.submit-button:hover:not(:disabled) {
  background-color: #2563eb;
}

.submit-button:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
  
  
  .form-wrapper {
    padding: 2.5rem;
  }
}

@media (max-width: 767px) {
  .form-wrapper {
    padding: 1.5rem;
    margin: 0 0.5rem;
  }
  
  .header-content {
    flex-direction: column;
    gap: 1.5rem;
  }
  
  .main-content {
    max-width: 100%;
  }
  
  .form-title {
    font-size: 1.5rem;
  }
  
  .personal-data-form-container {
    padding: 1rem 0.5rem;
  }
  
  /* Reposicionar banner en mobile: arriba del título */
  .discount-banner {
    position: relative !important;
    top: auto !important;
    right: auto !important;
    transform: none !important;
    align-self: center;
    order: -1; /* Mover arriba del main-content */
    margin-bottom: 1.5rem;
  }
  
  .discount-content {
    width: 240px !important;
    height: auto !important;
    min-height: 80px;
    padding: 0.875rem 1rem;
  }
  
  .discount-badge {
    top: -6px !important;
    right: -6px !important;
    padding: 0.375rem 0.625rem;
    font-size: 0.875rem;
    min-width: 40px;
    height: 28px;
  }
  
  .discount-text {
    font-size: 0.8rem;
    text-align: center;
  }
  
  /* Modificar elementos decorativos en mobile */
  .discount-content::before {
    width: 120px !important;
    height: 45px !important;
    top: -22px !important;
    left: 160px !important;
  }
  
  .discount-content::after {
    width: 35px !important;
    height: 35px !important;
    top: 80px !important;
    left: -10px !important;
  }
  
  .program-badge {
    width: 100%;
    max-width: 300px;
    min-height: auto;
    padding: 12px;
  }
  
  .program-text {
    font-size: 14px;
    line-height: 20px;
    -webkit-line-clamp: 4;
  }
  
  /* Estilos responsivos manejados por _inputs-shared.scss */

}

/* Focus states for accessibility */

/* Estilos para el campo de celular */
.phone-input-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.country-code-select {
  width: 80px;
  height: 48px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 12px;
  background-color: #f9fafb;
  font-size: 0.875rem;
  color: #374151;
  cursor: pointer;
}

.phone-number-input {
  flex: 1;
  height: 48px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0 16px;
  font-size: 0.875rem;
  color: #374151;
  background-color: white;
  transition: border-color 0.2s ease;
}

.phone-number-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.phone-number-input::placeholder {
  color: #9ca3af;
}

/* Estilos para mensajes de error */
.validation-message {
  font-size: 0.75rem;
  color: #dc2626;
  margin-top: 0.25rem;
  display: block;
}

.phone-error {
  color: #dc2626;
}

/* Estilos para el texto de contacto */
.contact-text {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #1a1a1a !important;
  margin-top: 8px;
  text-align: left;
  display: block;
}

</style>
